import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../Reveal";
import { IMG } from "../../data/content";

export const AboutIntro = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section data-testid="about-intro" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-14 lg:grid-cols-12 lg:gap-20 items-center">
        <div className="lg:col-span-6">
          <Overline>Who We Are</Overline>
          <Reveal>
            <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight text-sml-charcoal text-balance">
              Professional Property Solutions. Built Around Your Needs.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-sml-charcoal/70 text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                SML Property Solutions (Pty) Ltd is a dynamic, 100% Black-owned Level 1 B-BBEE
                company established in 2019. We specialise in professional horticultural services,
                cleaning services, hygiene solutions and the supply of quality cleaning and hygiene products.
              </p>
              <p>
                We support commercial, industrial, residential and public-sector clients with dependable
                solutions that create cleaner, healthier, safer and more attractive environments.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/about"
              data-testid="about-learn-more"
              className="group mt-10 inline-flex items-center gap-2 rounded-sm bg-sml-forest text-white font-medium px-6 py-3.5 hover:bg-sml-green transition-colors active:scale-[0.98]"
            >
              Learn More About SML
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-6" ref={ref}>
          <div className="grid grid-cols-5 grid-rows-6 gap-4 h-[460px] lg:h-[560px]">
            <div className="col-span-3 row-span-4 overflow-hidden rounded-sm">
              <motion.img style={{ y }} src={IMG.glassBuilding} alt="Green corporate building" className="h-[115%] w-full object-cover" />
            </div>
            <div className="col-span-2 row-span-3 overflow-hidden rounded-sm">
              <img src={IMG.manicured} alt="Manicured corporate lawn" className="h-full w-full object-cover" />
            </div>
            <div className="col-span-2 row-span-3 overflow-hidden rounded-sm bg-sml-forest text-white p-6 flex flex-col justify-between">
              <span className="font-mono-sml text-[10px] uppercase tracking-[0.2em] text-sml-bronze">Since 2019</span>
              <div>
                <div className="font-display text-4xl">4+</div>
                <div className="text-white/70 text-sm mt-1">Service divisions under one trusted provider</div>
              </div>
            </div>
            <div className="col-span-3 row-span-2 overflow-hidden rounded-sm">
              <img src={IMG.cleaningMop} alt="Professional cleaning" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
